/*
 * @Author: Sergiy Samborskiy
 * @Date: 2017-11-15 15:47:13
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2017-11-28 19:08:17
 */

import * as React from "react";
import { connect } from "react-redux";
import * as _ from "lodash";

import Ports from './Ports/Component';
import Map from './Map/Component';
import Management from './Management';

import Areas from './Areas/Areas';

import { getArea, updateArea, deleteArea } from 'actions/regions/areas';
import {getCountries} from "actions/countries";

import { execute } from 'store/configureStore';

import { createArea } from "sagas/regions/areas";

import api from 'services';

class AreaEditor extends React.Component {

    constructor(props) {
        super(props);

        this.toggleMainPort = this.toggleMainPort.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
        this.togglePort = this.togglePort.bind(this);
        this.showPort = this.showPort.bind(this);

        this.addPortToRegion = this.addPortToRegion.bind(this);
        this.onChangePortFromAutoComplete = this.onChangePortFromAutoComplete.bind(this);

        this.onChangeArea = this.onChangeArea.bind(this);
        this.createAreaOnServer = this.createAreaOnServer.bind(this);
        this.updateAreaOnServer = this.updateAreaOnServer.bind(this);
        this.deleteAreaOnServer = this.deleteAreaOnServer.bind(this);
        this.createNewArea = this.createNewArea.bind(this);

        this.handleAreaPathReady = this.handleAreaPathReady.bind(this);

        this.toggleRecalculate = this.toggleRecalculate.bind(this);
        this.toggleShowMarkersOnlyInThisArea = this.toggleShowMarkersOnlyInThisArea.bind(this);
        this.getDefaultArea = this.getDefaultArea.bind(this);

        this.changeMapView = this.changeMapView.bind(this);

        this.toggleShowPorts = this.toggleShowPorts.bind(this);
        this.toggleShowAreas = this.toggleShowAreas.bind(this);
        this.selectParentArea = this.selectParentArea.bind(this);

        this.areaPath = [];
        this.state = {
            area: this.getDefaultArea(props.areaId, props.area),
            recalculateAreaPorts: false,
            areaId: undefined,
            showMarkersOnlyInThisArea: false,
            showPortOnMap: undefined,
            portFromAutoComplete: {
                name: '',
            },
            ports: {
                items: [],
            },
            showView: 'map',
            showChilds: 'ports'
        };
    }

    componentDidMount() {
      this.props.getCountries();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const area = this.getDefaultArea(nextProps.areaId, nextProps.area);
        const areaChanged = this.props.areaId !== nextProps.areaId;
        const newState = {
            ports: nextProps.ports,
            area: {
                ...this.state.area,
                childs: area.childs,
                mainPorts: area.mainPorts,
                areaCoordinatesPolygons: area.areaCoordinatesPolygons
            },
            recalculateAreaPorts: false,
            // showChilds: 'ports',
        };  

        if (this.state.showMarkersOnlyInThisArea) {
            newState.ports = this.getPortsFromArea(nextProps.ports, area);
        }

        if (areaChanged) {
            newState.area = area;
        }

        this.setState(newState);

        if (nextProps.areaId && areaChanged) {
            this.areaPath = [];

            api.getArea(nextProps.areaId).then(response => {
                this.setState({
                    area: this.getDefaultArea(nextProps.areaId, response.data),
                    recalculateAreaPorts: false,
                });
            });
        }
    }

    changeMapView(status) {
        this.setState({
            showView: status,
        }, () => {
            this.setState({
                area: this.getDefaultArea(this.props.areaId, this.state.area),
            }, () => {
                google.maps.event.trigger(window.mainMap, 'resize');

                let ports = this.getPortsFromArea(this.props.ports, this.state.area);

                ports = ports.items.map(item => ({
                    lng: item.coordinates[0],
                    lat: item.coordinates[1],
                }));

                if (ports.length === 0) {
                    return;
                }

                let bounds = new google.maps.LatLngBounds();

                for (const point of ports) {
                    bounds.extend(point);
                }

                window.mainMap.fitBounds(bounds);
            });
        });
    }

    showPort(port, isChilds = true) {
        const { area } = this.state;

        if (isChilds) {
            for (let id of area.childs) {
                if (port._id === id) {
                    area.showPortOnMap = id;
                }
            }
        } else {
            area.showPortOnMap = port._id;
        }

        this.setState({
            area,
        });
    }

    getDefaultArea(id, newArea = {}) {
        return {
            _id: id,
            isNew: id === undefined,
            showPortOnMap: undefined,
            name: '',
            areaCoordinatesPolygons: {
                type: "MultiPolygon",
                coordinates: [],
            },
            ...newArea,
            childs: new Set(newArea ? newArea.childs : []),
            mainPorts: new Set(newArea ? newArea.mainPorts : []),
        };
    }

    getPortsFromArea(nextPorts, area) {
        let ports = { items: [] };

        ports.items = nextPorts.items.filter((port) => {
           return area.childs.has(port._id);
        });

        return ports;
    }

    toggleShowMarkersOnlyInThisArea(value) {
        let ports = [];

        if (value) {
            ports = this.getPortsFromArea(this.props.ports, this.state.area);
        } else {
            ports = this.props.ports;
        }

        this.setState({
            showMarkersOnlyInThisArea: value,
            ports,
        });
    }

    toggleRecalculate(value) {
        this.setState({
            recalculateAreaPorts: value,
        });
    }

    deleteAreaOnServer() {
        const prevArea = this.state.area;

        this.setState({
            area: {
                ...this.getDefaultArea(),
                isNew: true,
                showPortOnMap: undefined,
            },
            areaId: '',
            showMarkersOnlyInThisArea: false,
            recalculateAreaPorts: false,
        }, () => {
            this.props.deleteArea(prevArea);
        });
    }

    updateAreaOnServer({ setAreaAsDefault }) {
        this.computeNextArea((area) => {
            this.props.updateArea({
                ...area,
                areaCoordinatesPolygons: area.areaCoordinatesPolygons && 
                    area.areaCoordinatesPolygons.coordinates,
                setAreaAsDefault,
            });
        });
    }

    createAreaOnServer({ setAreaAsDefault }) {
        this.computeNextArea(async (area) => {
            const toSave = {
                ...area,
                areaCoordinatesPolygons: area.areaCoordinatesPolygons && area.areaCoordinatesPolygons.coordinates,
                setAreaAsDefault,
            };
            const result = await execute(createArea, toSave);
            if (result) { // may be undefined on error
                this.props.selectArea(result._id);
            }
        });
    }

    computeNextArea(cb) {
        let coords = [];

        for (const path of this.areaPath) {
            coords.push([this.getPolygonCoords(path)]);
        }

        this.setState(state => ({
            area: {
                ...state.area,
                areaCoordinatesPolygons: {
                    ...state.areaCoordinatesPolygons,
                    type: "MultiPolygon",
                    coordinates: coords,
                },
                showPortOnMap: undefined,
            }
        }), () => {
            cb({
                ...this.state.area,
                recalculatePorts: this.state.recalculateAreaPorts
            });
        });
    }

    onChangeArea(area) {
        this.setState({
            area,
        });
    }

    createNewArea() {
        this.setState({
            area: this.getDefaultArea(undefined),
            areaId: undefined,
            showMarkersOnlyInThisArea: false,
            ports: this.props.ports,
            showPortOnMap: undefined,
        }, () => {
            this.areaPath = [];
            this.props.selectArea(this.state.area._id)
        });
    }

    getPolygonCoords(path) {
        return path.getArray().map(item => [ item.lng(), item.lat() ]);
    }

    handleAreaPathReady(polygons) {
        this.areaPath = polygons;
    }

    onChangePortFromAutoComplete(portFromAutoComplete) {
        this.setState({
            portFromAutoComplete,
        });
    }

    addPortToRegion() {
        this.addPort(this.state.portFromAutoComplete);
    }

    toggleMainPort(port, value) {
        let { area } = this.state;

        if (value) {
            area.mainPorts.add(port._id);
        }
        else {
            area.mainPorts.delete(port._id);
        }

        this.setState({
            area: {
                ...area,
                showPortOnMap: undefined,
            },
            recalculateAreaPorts: false,
        });
    }

    removePorts(ports) {
        const { area } = this.state;

        ports.forEach((item) => {
            area.childs.delete(item._id);
            area.mainPorts.delete(item._id);
        });

        this.setState({
            area: {
                ...area,
                showPortOnMap: undefined,
            },
            recalculateAreaPorts: false,

        });
    }

    removePort(port) {
        const { area } = this.state;

        area.mainPorts.delete(port._id);
        area.childs.delete(port._id);

        this.setState({
            area: {
                ...area,
                showPortOnMap: undefined,
            },
            recalculateAreaPorts: false,
        });
    }

    addPort(port) {
        const { area } = this.state;

        area.childs.add(port._id);

        this.setState({
            area: {
                ...area,
                showPortOnMap: undefined,
            },
            portFromAutoComplete: {
                name: '',
            }
        });
    }

    togglePort(port) {
        const { area } = this.state;

        if (Array.isArray(port)) {
            return this.removePorts(port);
        }

        if (area.childs.has(port._id)) {
            this.removePort(port);
        }
        else {
            this.addPort(port);
        }
    }

    toggleShowPorts() {
        this.setState({
            showChilds: 'ports',
        });
    }

    async toggleShowAreas() {
        this.setState({
            showChilds: 'areas',
        });
    }

    selectParentArea(areaId) {
        api.getArea(areaId).then(response => {
            this.setState({
                area: this.getDefaultArea(areaId, response.data),
                recalculateAreaPorts: false,
            }, () => {
                this.props.selectParentArea(this.state.area._id);
            });
        });
    }

    render() {
        const { showMarkersOnlyInThisArea, 
                ports, 
                portFromAutoComplete, 
                area, 
                recalculateAreaPorts, 
                showView,
                showChilds } = this.state;
        const { user } = this.props;

        return (
            <div className="row">
                <div className='col-xs-4'>
                    {
                        showChilds === 'ports' ?
                            <Ports
                                portFromAutoComplete={portFromAutoComplete}
                                selectedArea={area}
                                toggleMainPort={this.toggleMainPort}
                                removePort={this.removePort}
                                showPort={this.showPort}
                                addPort={this.addPort}
                                onChangeArea={this.onChangeArea}
                                onChangePortFromAutoComplete={this.onChangePortFromAutoComplete}
                                toggleShowPorts={this.toggleShowPorts}
                                toggleShowAreas={this.toggleShowAreas}
                                showChilds={showChilds}
                            />
                        :
                            <Areas 
                                toggleShowPorts={this.toggleShowPorts}
                                toggleShowAreas={this.toggleShowAreas}
                                area={area}
                                selectParentArea={this.selectParentArea}
                                showChilds={showChilds}
                            />
                    }
                </div>
                <div className='col-xs-8'>
                    <Management
                        area={area}
                        user={user}
                        showView={showView}
                        portFromAutoComplete={portFromAutoComplete}
                        changeMapView={this.changeMapView}
                        addPortToRegion={this.addPortToRegion}
                        onChangeArea={this.onChangeArea}
                        createNewArea={this.createNewArea}
                        createAreaOnServer={this.createAreaOnServer}
                        updateAreaOnServer={this.updateAreaOnServer}
                        deleteAreaOnServer={this.deleteAreaOnServer}
                        recalculateOnSave={recalculateAreaPorts}
                        toggleRecalculate={this.toggleRecalculate}
                        showMarkersOnlyInThisArea={showMarkersOnlyInThisArea}
                        toggleShowMarkersOnlyInThisArea={this.toggleShowMarkersOnlyInThisArea}
                        addPort={this.addPort}
                        router={this.props.router}
                        countries={this.props.countries}
                    />
                    <Map
                        showView={showView}
                        area={area}
                        ports={ports}
                        onChangeArea={this.onChangeArea}
                        onAreaPathReady={this.handleAreaPathReady}
                        createNewArea={this.createNewArea}
                        togglePort={this.togglePort}
                        showMarkersOnlyInThisArea={showMarkersOnlyInThisArea}
                        updateAreaOnServer={this.updateAreaOnServer}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const area = _.find(state.areas.items, { _id: props.areaId });
    return {
        user: state.user.user,
        area,
        ports: state.ports,
        countries: _.get(state, 'countries.items', [])
    };
}

export const Editor = connect(mapStateToProps, {
    getArea,
    updateArea,
    deleteArea,
    getCountries
})(AreaEditor);

export { Editor as AreaEditor };



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/AreaEditor.jsx